import React, { useEffect, useRef, useState } from "react";
import { Button, Col, Row } from "reactstrap";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import ListItemOder from "./list";
import { get, post } from "../../helpers/api_helper";
import "./index.scss";
import { isMobile } from 'react-device-detect';
import toastr from 'toastr';
import slugify from "slugify";
import { STATUS_TITLE, STATUS, TIME_FIELD_INVENTORY } from "../../constants";
import { useNavigate } from "react-router";
import ModalConfirm from "../../components/Modal/modalConfirm";
import moment from "moment";

const LIMIT = 10;
let timeOutSearch;


const ListOder = () => {
  const navigate = useNavigate()
  const [loading, setLoading] = useState(false)
  const [successfulExportVatItem, setSuccessfulExportVatItem] = useState(null)
  const [list, setList] = useState({
    DRAFT: [],
    CREATED: [],
    CONFIRMED: [],
    PREPARING: [],
    CHECK_PACKAGE: [],
    IN_PACKAGE: [],
    DELIVERING: [],
    WAIT_CUSTOMER_PICK_UP: [],
    WAITING_PAY: [],
    WAITING_EXPORT_VAT: [],
    SUCCESSFUL_EXPORT_VAT: [],
    CANCELED: [],
    FINISHED: [],
    externalBill: {
      DRAFT: [],
      CREATED: [],
      CONFIRMED: [],
      PREPARING: [],
      CHECK_PACKAGE: [],
      IN_PACKAGE: [],
      DELIVERING: [],
      WAIT_CUSTOMER_PICK_UP: [],
      WAITING_EXPORT_VAT: [],
      WAITING_PAY: [],
      SUCCESSFUL_EXPORT_VAT: [],
    }
  });

  const [offset, setOffset] = useState({
    FINISHED: 0,
    CANCELED: 0,
    SUCCESSFUL_EXPORT_VAT: 0,
  });

  const [total, setTotal] = useState({
    FINISHED: 0,
    CANCELED: 0,
    SUCCESSFUL_EXPORT_VAT: 0,
  });

  const [searchKeyPagi, setSearchKeyPagi] = useState({
    FINISHED: "",
    CANCELED: "",
    SUCCESSFUL_EXPORT_VAT: "",
  });
  const [searchKey, setSearchKey] = useState('');

  const [show, setShow] = useState({});

  useEffect(() => {
    if (Object.keys(show).length > 0) {
      localStorage.setItem("DEFAULT_STATUS_SHOW", JSON.stringify(show))
    } else {
      let DEFAULT_STATUS_SHOW = localStorage.getItem("DEFAULT_STATUS_SHOW");
      if (!DEFAULT_STATUS_SHOW || Object.keys(JSON.parse(DEFAULT_STATUS_SHOW)).length === 0 || Object.keys(JSON.parse(DEFAULT_STATUS_SHOW)).find(e => !STATUS[e])) {
        DEFAULT_STATUS_SHOW = {
          DRAFT: false,
          CREATED: true,
          CONFIRMED: !isMobile,
          PREPARING: !isMobile,
          CHECK_PACKAGE: !isMobile,
          IN_PACKAGE: !isMobile,
          DELIVERING: false,
          WAIT_CUSTOMER_PICK_UP: false,
          WAITING_PAY: !isMobile,
          FINISHED: false,
          CANCELED: false,
          WAITING_EXPORT_VAT: false,
          SUCCESSFUL_EXPORT_VAT: false,
        }
      } else {
        DEFAULT_STATUS_SHOW = JSON.parse(DEFAULT_STATUS_SHOW)
      }
      setShow(DEFAULT_STATUS_SHOW)

    }
  }, [show])

  const [showDropdown, setShowDropdown] = useState(false);

  const fetchAPI = (payload) => {

    const {
      offset = 0,
      limit = LIMIT,
      status,
      search,
      isExportVAT,
      isPurchase,
      path = 'list'
    } = payload;
    return get(
      `/bills/${path}`,
      {
        params: {
          offset,
          limit,
          ...(search ? { search } : {}),
          ...(status ? { status } : {}),
          ...(isExportVAT ? { isExportVAT } : {}),
          ...(isPurchase ? { isPurchase } : {}),
        }
      }
    ).then((data) => {
      return data;
    });
  };

  const initPage = () => {
    Promise.all([
      get("/bills/kanban"),
      get(`/bills/list?offset=0&limit=${LIMIT}&status=CANCELED`),
      get(`/bills/list?offset=0&limit=${LIMIT}&isExportVAT=1`),
      get(`/bills/list?offset=0&limit=${LIMIT}&status=FINISHED`),

    ]).then((res) => {
      const { externalBill, ...restRes0 } = res[0];
      Object.keys(externalBill).forEach(key => {
        externalBill[key] = externalBill[key].map(item => ({
          id: item.billId,
          createdAt: item.createdAt,
          data: item.data?.bill,
          source: item.source,
        }))
      })

      setList({
        ...restRes0,
        CANCELED: res[1].list,
        SUCCESSFUL_EXPORT_VAT: res[2].list,
        FINISHED: res[3].list,
        externalBill,
      });
      setTotal({
        CANCELED: res[1].total,
        SUCCESSFUL_EXPORT_VAT: res[2].total,
        FINISHED: res[3].total,
      });
    });
  };

  useEffect(() => {
    initPage();
  }, []);

  const handleShowMoreFinished = () => {
    let newOffset;
    newOffset = offset.FINISHED + LIMIT;
    fetchAPI({
      offset: newOffset,
      limit: LIMIT,
      status: STATUS.FINISHED,
      search: searchKeyPagi.FINISHED
    }).then((data) => {
      setList({ ...list, FINISHED: [...list.FINISHED, ...data.list] });
      setOffset({
        ...offset,
        FINISHED: data.offset
      });
    });
  };

  const handleSearchFinished = (key) => {
    setSearchKeyPagi({
      ...searchKeyPagi,
      FINISHED: key,
    })
    clearTimeout(timeOutSearch);
    timeOutSearch = setTimeout(async () => {
      const finishedList = await fetchAPI({
        offset: 0,
        limit: LIMIT,
        status: STATUS.FINISHED,
        search: key
      });
      setList({
        ...list,
        FINISHED: finishedList.list
      });
      setTotal({
        ...total,
        FINISHED: finishedList.total
      });
    }, 300);
  };

  const handleShowMoreCanceled = () => {
    let newOffset;
    newOffset = offset.CANCELED + LIMIT;
    fetchAPI({
      offset: newOffset,
      limit: LIMIT,
      status: STATUS.CANCELED,
      search: searchKeyPagi.CANCELED
    }).then((data) => {
      setList({ ...list, CANCELED: [...list.CANCELED, ...data.list] });
      setOffset({
        ...offset,
        CANCELED: data.offset
      });
    });
  };

  const handleShowMoreSuccessfulExportVat = () => {
    let newOffset;
    newOffset = offset.SUCCESSFUL_EXPORT_VAT + LIMIT;

    fetchAPI({
      offset: newOffset,
      limit: LIMIT,
      isExportVAT: 1,

      search: searchKeyPagi.SUCCESSFUL_EXPORT_VAT
    }).then((data) => {
      setList({ ...list, SUCCESSFUL_EXPORT_VAT: [...list.SUCCESSFUL_EXPORT_VAT, ...data.list] });
      setOffset({
        ...offset,
        SUCCESSFUL_EXPORT_VAT: data.offset
      });
    });
  };


  const handleSearchCanceled = (key) => {
    setSearchKeyPagi({
      ...searchKeyPagi,
      CANCELED: key,
    })
    clearTimeout(timeOutSearch);
    timeOutSearch = setTimeout(async () => {
      const canceledList = await fetchAPI({
        offset: 0,
        limit: LIMIT,
        status: STATUS.CANCELED,
        search: key
      });
      setList({
        ...list,
        CANCELED: canceledList.list
      });
      setTotal({
        ...total,
        CANCELED: canceledList.total
      });
    }, 300);
  };

  const handleSearchSuccessfulExportVat = (key) => {
    setSearchKeyPagi({
      ...searchKeyPagi,
      SUCCESSFUL_EXPORT_VAT: key,
    })

    clearTimeout(timeOutSearch);
    timeOutSearch = setTimeout(async () => {
      const successfulExportVatList = await fetchAPI({
        offset: 0,
        limit: LIMIT,
        isExportVAT: 1,
        search: key
      });
      setList({
        ...list,
        SUCCESSFUL_EXPORT_VAT: successfulExportVatList.list
      });
      setTotal({
        ...total,
        SUCCESSFUL_EXPORT_VAT: successfulExportVatList.total
      });
    }, 300);
  };

  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [dropdownRef]);

  const handleShow = (state) => {

    if (!show[state] && Object.values(show).filter(e => !!e).length >= 6) {
      toastr.error("Không được hiển thị quá 6 cột. Vui lòng ẩn các cột khác trước khi hiện cột mới")
    }
    else {
      setShow((show) => ({ ...show, [state]: !show[state] }))
    }
  }

  const renderBySearch = (list = []) => {

    if (searchKey === "") {
      return list
    }

    const lowserSearchKey = slugify(searchKey).toLowerCase();
    return list.filter(bill => {
      if (bill.id.toLowerCase().includes(searchKey.toLowerCase()) || bill.phone.includes(lowserSearchKey)) {
        return true;
      }
      if (bill?.codeVAT?.toLowerCase().includes(searchKey.toLowerCase())) {
        return true;
      }
      if (bill.name.split(" ").map(slugify).join(" ").toLowerCase().includes(lowserSearchKey)) {
        return true;
      }
      return false;
    })
  }

  const renderExternalBillBySearch = (list, searchKey) => {
    if (!list) {
      return []
    }
    if (searchKey === "") {
      return list
    }

    return list.filter(bill => {
      const lowserSearchKey = slugify(searchKey).toLowerCase();
      if (bill.id.toLowerCase().includes(searchKey.toLowerCase())) {
        return true;
      }
      const data = bill.data;
      if (data) {
        if (data.phone?.includes(lowserSearchKey)) {
          return true;
        }

        if (data.codeVAT?.toLowerCase().includes(searchKey.toLowerCase())) {
          return true;
        }

        if (data.name?.split(" ").map(slugify).join(" ").toLowerCase().includes(lowserSearchKey)) {
          return true;
        }

      }

      return false;
    })
  }

  const updateSuccessfulExportVat = (item) => {
    setLoading(true);
    post(`/bills/scan-inventory/${item.id}`, {
      type: TIME_FIELD_INVENTORY.SUCCESSFUL_EXPORT_VAT
    }, {})
      .then(() => {
        const newExternalBills = {
          WAITING_EXPORT_VAT: list.externalBill.WAITING_EXPORT_VAT.filter(i => i.id !== item.id),
          SUCCESSFUL_EXPORT_VAT: [
            {
              ...item,
              createdAt: moment().toISOString(),
            },
            ...list.externalBill.SUCCESSFUL_EXPORT_VAT,
          ]
        }
        setList({
          ...list,
          externalBill: newExternalBills
        })
        setSuccessfulExportVatItem(null)
        toastr.success('Chuyển đơn thành công')
      })
      .catch(() => {
        toastr.error('Không thể chuyển đơn')
      })
      .finally(() => {
        setLoading(false);
      });
  }

  const onPrintExternalBill = (item) => {
    window.open(`/print-external-bill-by-id/${item.id}`, '_blank');

  }
  const onConfirmAndPrintExternalBill = (item) => {
    post(`/bills/scan-inventory/${item.id}`, {
      type: TIME_FIELD_INVENTORY.CONFIRMED
    }, {})
      .then(() => {
        toastr.success('Chuyển đơn thành công')
        window.open(`/print-external-bill-by-id/${item.id}`, '_blank');

      })
      .catch(() => {
        toastr.error('Không thể chuyển đơn')
      })
      .finally(() => {
        setLoading(false);
      });
  }


  return (
    <div className="list-oder-page">
      <Breadcrumbs title="Đơn hàng" breadcrumbItem="danh sách đơn hàng" />
      <Row>
        {Object.entries(show).filter(([key, state]) => state && !['FINISHED', 'CANCELED', 'SUCCESSFUL_EXPORT_VAT'].includes(key)).length ? <Col md={2}>
          <div className="list-item_fieldSearch">
            <input
              className="list-item_input"
              placeholder="Tìm kiếm đơn"
              onChange={(e) => setSearchKey(e.target.value)}
            />
          </div>
        </Col> : null}
        {show.FINISHED ? <Col md={2}>
          <div className="list-item_fieldSearch">
            <input
              className="list-item_input"
              placeholder="Tìm kiếm đơn hoàn thành"
              onChange={(e) => handleSearchFinished(e.target.value)}
            />
          </div>
        </Col> : null}
        {show.CANCELED ? <Col md={2}>
          <div className="list-item_fieldSearch">
            <input
              className="list-item_input"
              placeholder="Tìm kiếm đơn bị huỷ"
              onChange={(e) => handleSearchCanceled(e.target.value)}
            />
          </div>
        </Col> : null}

        {show.SUCCESSFUL_EXPORT_VAT ? <Col md={2}>
          <div className="list-item_fieldSearch">
            <input
              className="list-item_input"
              placeholder="Tìm kiếm đơn đã xuất HĐ đỏ"
              onChange={(e) => handleSearchSuccessfulExportVat(e.target.value)}
            />
          </div>
        </Col> : null}

        <Col>
          <div ref={dropdownRef} className="list-oder-page_wrapDropdown">
            <div
              onClick={() => setShowDropdown(!showDropdown)}
              className={`list-oder-page_buttonDropdown ${showDropdown && "list-oder-page_buttonDropdown-show"
                }`}
            >
              Hiển thị cột
            </div>
            {!isMobile ?
              <div
                className={`list-oder-page_dropdown ${showDropdown && "list-oder-page_dropdown-show"
                  }`}
              >
                {Object.values(STATUS).map(state =>
                  <div className="list-oder-page_field">
                    <label htmlFor={state}>{STATUS_TITLE[state]}</label>
                    <input
                      id={state}
                      checked={show[state]}
                      type="checkbox"
                      onChange={() => handleShow(state)}
                    />
                  </div>
                )}

              </div>
              : <div
                className={`list-oder-page_dropdown ${showDropdown && "list-oder-page_dropdown-show"
                  }`}
              >
                {Object.values(STATUS).map(state =>
                  <div className="list-oder-page_field">
                    <label htmlFor={state}>{STATUS_TITLE[state]}</label>
                    <input
                      id={state}
                      checked={show[state]}
                      type="radio"
                      name="radio-status"
                      onClick={() => {
                        setShow({ [state]: true })
                        setShowDropdown(false)
                      }}
                    />
                  </div>
                )}
              </div>}
          </div>
        </Col>

      </Row>
      <div className="list-oder-page_table">
        <Row>

          {
            Object.values(STATUS).filter(key => show[key] && !['CANCELED', 'FINISHED', 'WAITING_EXPORT_VAT', 'SUCCESSFUL_EXPORT_VAT'].includes(key)).map((key) =>
              <Col md={3} lg={2} sm={12} className="order-status-col" key={key}>
                <ListItemOder
                  status={key}
                  title={STATUS_TITLE[key]}
                  listExternalData={renderExternalBillBySearch(list.externalBill[key], searchKey)}
                  listData={renderBySearch(list[key])}
                  total={renderBySearch(list[key]).length}
                  renderActionExternalItem={(item) => <div className="d-flex gap-2">
                    {item?.data && <div className="d-flex gap-2">
                      <Button
                        color="info"
                        size="sm"
                        onClick={() => {
                          onPrintExternalBill(item)
                        }}
                      >
                        In
                      </Button>
                      {key === STATUS.CREATED && <Button
                        color="info"
                        size="sm"
                        onClick={() => {
                          onConfirmAndPrintExternalBill(item)
                        }}
                      >
                        Xác nhận & In
                      </Button>}

                    </div>
                    }

                  </div>}
                />
              </Col>
            )}


          {show.WAITING_EXPORT_VAT && (
            <Col md={3} lg={2} sm={12} className="order-status-col">
              <ListItemOder
                status="WAITING_EXPORT_VAT"
                title={STATUS_TITLE.WAITING_EXPORT_VAT}
                listExternalData={renderExternalBillBySearch(list.externalBill.WAITING_EXPORT_VAT, searchKey)}
                renderActionExternalItem={(item, source) => <div className="d-flex gap-2">
                  {item?.data && <Button
                    color="info"
                    size="sm"
                    onClick={() => {
                      onPrintExternalBill(item)
                    }}
                  >
                    In
                  </Button>}
                  <Button
                    color="info"
                    size="sm"
                    onClick={() => {
                      setSuccessfulExportVatItem(item)
                    }}
                  >
                    Đã Xuất HĐ
                  </Button>


                </div>}
                listData={renderBySearch(list.WAITING_EXPORT_VAT)}

                total={renderExternalBillBySearch(list.externalBill.WAITING_EXPORT_VAT, searchKey).length + renderBySearch(list.WAITING_EXPORT_VAT).length}
              />
            </Col>
          )}
          {show.SUCCESSFUL_EXPORT_VAT && (
            <Col md={3} lg={2} sm={12} className="order-status-col" >
              <ListItemOder
                status="SUCCESSFUL_EXPORT_VAT"
                title={STATUS_TITLE.SUCCESSFUL_EXPORT_VAT}
                listExternalData={renderExternalBillBySearch(list.externalBill.SUCCESSFUL_EXPORT_VAT, searchKeyPagi.SUCCESSFUL_EXPORT_VAT)}
                listData={list.SUCCESSFUL_EXPORT_VAT}

                total={renderExternalBillBySearch(list.externalBill.SUCCESSFUL_EXPORT_VAT, searchKeyPagi.SUCCESSFUL_EXPORT_VAT).length + total.SUCCESSFUL_EXPORT_VAT}
                handleShowMore={handleShowMoreSuccessfulExportVat}
              />
            </Col>
          )}

          {show.FINISHED && (
            <Col md={3} lg={2} sm={12} className="order-status-col" >
              <ListItemOder
                status="FINISHED"
                title={STATUS_TITLE.FINISHED}
                listData={list.FINISHED}
                total={total.FINISHED}
                handleShowMore={handleShowMoreFinished}
              />
            </Col>
          )}
          {show.CANCELED && (
            <Col md={3} lg={2} sm={12} className="order-status-col" >
              <ListItemOder
                status="CANCELED"
                title={STATUS_TITLE.CANCELED}
                listData={list.CANCELED}
                total={total.CANCELED}
                handleShowMore={handleShowMoreCanceled}
              />
            </Col>
          )}
        </Row>
      </div>

      <ModalConfirm
        isLoading={loading}
        isOpen={successfulExportVatItem !== null}
        title="Đã xuất hoá đơn"
        desc={`Bạn có chắc muốn chuyển đơn này thành đã xuất HĐ?`}
        handleAccept={() => updateSuccessfulExportVat(successfulExportVatItem)}
        handleCancel={() => setSuccessfulExportVatItem(null)} />
    </div>
  );
};

export default ListOder;
